import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("ul", {
        "data-slot": "sidebar-menu",
        "data-sidebar": "menu",
        class: _normalizeClass($setup.cn('flex w-full min-w-0 flex-col gap-1 list-none', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
